/**
 * Reads the `portalId` query parameter from the current page URL.
 *
 * When the QR Code Generator is embedded as a HubSpot iframe, HubSpot
 * appends `?portalId=<id>` to the iframe src automatically.
 *
 * @returns {number|null} The portal ID as a number, or null if not present / invalid.
 */
export const getPortalId = () => {
  try {
    const params = new URLSearchParams(window.location.search); // Debug log to check all query params
    const raw = params.get('portalId');
    if (!raw) return null;
    const id = Number(raw);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
};

export const getSlug = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('slug');
    return slug || null;
  } catch (error) {
    console.error('Slug Error:', error);
    return null;
  }
};
